module.exports = __webpack_public_path__ + "img/gameit.2808fb83.jpg";